import "./intro.scss"

export default function Intro() {
  return (
    <div className="intro" id="intro">

      <div className="left">
        <div className="imgContainer">
          <img src="assets/clau.JPG" alt=""/>
        </div>
      </div>

      <div className="right">
        <div className="wrapper">
          <h2>Hi , I'm</h2>
          <h1>Claudia Cristina</h1>
          <h1>Tomus</h1>
        </div>
      </div>
    </div>
  )
}
